import restBase from './restBase';
export default {
  fake(url, param, needHandleAuthorizationCheck = false, listMessageIgnoreError = []) {
    if (this.API_INFO == null || this.API_INFO[url] == null) return null;
    let info = this.API_INFO[url].get;
    if (info && info.use_sample) {
      return new Promise((resolve) => {
        let sample = this.SAMPLE[url];
        setTimeout(resolve(sample), 500);
      });
    } else if (info && info.use_mock) {
      return restBase.get(
        'http://182.195.81.153:15019' + '/monitoring/system' + url,
        param,
        true,
        false,
        {},
        needHandleAuthorizationCheck,
        listMessageIgnoreError
      );
    }
    return null;
  },
  get(
    url,
    param = {},
    loadingBar = true,
    ignoreError = false,
    ext = {},
    needHandleAuthorizationCheck = false,
    listMessageIgnoreError = [],
    config = {}
  ) {
    if (restBase.useFake) {
      let promise = this.fake(url, param);
      if (promise) return promise;
    }
    return restBase.get(
      this.prefix + url,
      param,
      loadingBar,
      ignoreError,
      ext,
      needHandleAuthorizationCheck,
      listMessageIgnoreError,
      config,
    );
  },
  delete(
    url,
    param = {},
    body = {},
    loadingBar = true,
    ignoreError = false,
    ext = {},
    needHandleAuthorizationCheck = false,
    listMessageIgnoreError = [],
    config = {}
  ) {
    if (restBase.useFake) {
      let promise = this.fake(url);
      if (promise) return promise;
    }
    return restBase.delete(
      this.prefix + url,
      param,
      body,
      loadingBar,
      ignoreError,
      ext,
      needHandleAuthorizationCheck,
      listMessageIgnoreError,
      config
    );
  },
  post(
    url,
    param = {},
    loadingBar = true,
    ignoreError = false,
    ext = {},
    needHandleAuthorizationCheck = false,
    listMessageIgnoreError = [],
    config = {}
  ) {
    if (restBase.useFake) {
      let promise = this.fake(url);
      if (promise) return promise;
    }
    return restBase.post(
      this.prefix + url,
      param,
      loadingBar,
      ignoreError,
      ext,
      needHandleAuthorizationCheck,
      listMessageIgnoreError,
      config
    );
  },
  put(
    url,
    param = {},
    loadingBar = true,
    ignoreError = false,
    ext = {},
    needHandleAuthorizationCheck = false,
    listMessageIgnoreError = [],
    config = {}
  ) {
    if (restBase.useFake) {
      let promise = this.fake(url);
      if (promise) return promise;
    }
    return restBase.put(
      this.prefix + url,
      param,
      loadingBar,
      ignoreError,
      ext,
      needHandleAuthorizationCheck,
      listMessageIgnoreError,
      config
    );
  }
};
